import axios from "axios";

const Common = {
  company: async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}company/verify/findAll`,
        {
          headers: {
            "x-access-token": localStorage.getItem("accessTokenFleetrax"),
            "email": localStorage.getItem("emailFleetrax"),
            "usertype": localStorage.getItem("userTypeFleetrax"),
          },
        }
      );
      return Array.isArray(response.data.data) ? response.data.data : [];
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.href = "/login";
      } else {
        console.error("Error:", error);
      }
      return [];
    }
  },
  state: async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}dropDown/verify/getStates`,
        {
          headers: {
            "x-access-token": localStorage.getItem("accessTokenFleetrax"),
            "email": localStorage.getItem("emailFleetrax"),
            "usertype": localStorage.getItem("userTypeFleetrax"),
          },
        }
      );
      return Array.isArray(response.data.data) ? response.data.data : [];
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.href = "/login";
      } else {
        console.error("Error:", error);
      }
      return [];
    }
  },
  district: async (id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}dropDown/verify/getDistricts/`,
        {
          params: { stateId: id },
          headers: {
            "x-access-token": localStorage.getItem("accessTokenFleetrax"),
            "email": localStorage.getItem("emailFleetrax"),
            "usertype": localStorage.getItem("userTypeFleetrax"),
          },
        }
      );
      return Array.isArray(response.data.data) ? response.data.data : [];
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.href = "/login";
      } else {
        console.error("Error:", error);
      }
      return [];
    }
  },
  tripType: async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}tripType/verify/findAll`,
        {
          headers: {
            "x-access-token": localStorage.getItem("accessTokenFleetrax"),
            "email": localStorage.getItem("emailFleetrax"),
            "usertype": localStorage.getItem("userTypeFleetrax"),
          },
        }
      );
      return Array.isArray(response.data.data) ? response.data.data : [];
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.href = "/login";
      } else {
        console.error("Error:", error);
      }
      return [];
    }
  },
  vehicleType: async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}vehicleType/verify/findAll`,
        {
          headers: {
            "x-access-token": localStorage.getItem("accessTokenFleetrax"),
            "email": localStorage.getItem("emailFleetrax"),
            "usertype": localStorage.getItem("userTypeFleetrax"),
          },
        }
      );
      return Array.isArray(response.data.data) ? response.data.data : [];
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.href = "/login";
      } else {
        console.error("Error:", error);
      }
      return [];
    }
  },
  shiftTime: async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}shiftTime/verify/findAll`,
        {
          headers: {
            "x-access-token": localStorage.getItem("accessTokenFleetrax"),
            "email": localStorage.getItem("emailFleetrax"),
            "usertype": localStorage.getItem("userTypeFleetrax"),
          },
        }
      );
      return Array.isArray(response.data.data) ? response.data.data : [];
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.href = "/login";
      } else {
        console.error("Error:", error);
      }
      return [];
    }
  },
  bloodGroup: async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}dropDown/verify/getBloodGroup`,
        {
          headers: {
            "x-access-token": localStorage.getItem("accessTokenFleetrax"),
            "email": localStorage.getItem("emailFleetrax"),
            "usertype": localStorage.getItem("userTypeFleetrax"),
          },
        }
      );
      return Array.isArray(response.data.data) ? response.data.data : [];
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.href = "/login";
      } else {
        console.error("Error:", error);
      }
      return [];
    }
  },
  getPaymentMode: async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}dropDown/verify/getPaymentMode`,
        {
          headers: {
            "x-access-token": localStorage.getItem("accessTokenFleetrax"),
            "email": localStorage.getItem("emailFleetrax"),
            "usertype": localStorage.getItem("userTypeFleetrax"),
          },
        }
      );
      return Array.isArray(response.data.data) ? response.data.data : [];
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.href = "/login";
      } else {
        console.error("Error:", error);
      }
      return [];
    }
  },
  getPayer: async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}dropDown/verify/getPayer`,
        {
          headers: {
            "x-access-token": localStorage.getItem("accessTokenFleetrax"),
            "email": localStorage.getItem("emailFleetrax"),
            "usertype": localStorage.getItem("userTypeFleetrax"),
          },
        }
      );
      return Array.isArray(response.data.data) ? response.data.data : [];
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.href = "/login";
      } else {
        console.error("Error:", error);
      }
      return [];
    }
  },
  getPaymentStatus: async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}dropDown/verify/getPaymentStatus`,
        {
          headers: {
            "x-access-token": localStorage.getItem("accessTokenFleetrax"),
            "email": localStorage.getItem("emailFleetrax"),
            "usertype": localStorage.getItem("userTypeFleetrax"),
          },
        }
      );
      return Array.isArray(response.data.data) ? response.data.data : [];
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.href = "/login";
      } else {
        console.error("Error:", error);
      }
      return [];
    }
  },
  getDriverLocation: async (id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}driver/getDriverLocation/${id}`,
      );
      return response.data.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.href = "/login";
      } else {
        console.error("Error:", error);
      }
      return null;
    }
  },
};

export default Common;
